import { evidenceItems } from "@/mocks/homeContent";

export default function EvidenceSection() {
  return (
    <section id="evidence" className="w-full bg-background-100">
      <div className="container-x py-12 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-primary-600">
              <i className="ri-puzzle-2-line" />
              证据拼图
            </p>
            <h2 className="font-heading mt-2 text-2xl font-black md:text-4xl">关键证据 · 核验进度</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-500">
              每一份深挖帖背后的原始素材都标注可信度等级，黑料深扒先过证据关，还原结论才站得住脚。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {evidenceItems.map((e) => (
            <article
              key={e.name}
              className="group rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                  <i className={`${e.icon} text-xl`} />
                </span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-bold text-secondary-900">
                  {e.rating}
                </span>
              </div>
              <h3 className="font-heading mt-4 text-base font-black text-foreground-950">{e.name}</h3>
              <p className="mt-2 min-h-[42px] text-xs leading-relaxed text-foreground-600">{e.desc}</p>
              <div className="mt-4 flex items-center gap-2">
                <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-secondary-100">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-accent-400 to-accent-600"
                    style={{ width: `${e.rate}%` }}
                  />
                </div>
                <span className="text-xs font-bold text-accent-700">{e.rate}</span>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-5 flex items-start gap-2 text-xs leading-relaxed text-foreground-500">
          <i className="ri-information-line mt-0.5 shrink-0 text-primary-500" />
          本站内容基于公开可查的网络讨论与素材整理归档，还原结论随新证据动态修正，不代表对任何个人或组织的定性判断。
        </p>
      </div>
    </section>
  );
}